import { Flex, Text } from "@radix-ui/themes";
import { CoreCompetencies } from "@/components/businessCard/CoreCompetencies";

export const Hero = () => {
  return (
    <Flex direction={"column"} gap={"6"} className={"mt-32"}>
      <Text
        weight={"bold"}
        align={"center"}
        className={"hero-title"}
      >
        안녕하세요, <br />웹 개발자{" "}
        <span
          style={{
            color: "var(--tomato-9)",
          }}
        >
          장종인
        </span>
        입니다.
      </Text>
      <Text
        size={"4"}
        weight={"medium"}
        color={"gray"}
        align={"center"}
      >
        <span
          style={{
            color: "var(--lime-8)",
            fontWeight: "bold",
          }}
        >
          Java
        </span>
        와{" "}
        <span
          style={{
            color: "var(--lime-8)",
            fontWeight: "bold",
          }}
        >
          React·Three.js
        </span>
        를 중심으로 웹 개발 경험을 쌓아왔습니다.
        <br />
        사용자 가치와 제품 완성도를 함께 높여갈 곳을 찾고 있습니다.
      </Text>

      <CoreCompetencies />
    </Flex>
  );
};
